import { render, staticRenderFns } from "./mzDiseaseDetail.vue?vue&type=template&id=1cfccd06&scoped=true"
import script from "./mzDiseaseDetail.vue?vue&type=script&lang=js"
export * from "./mzDiseaseDetail.vue?vue&type=script&lang=js"
import style0 from "./mzDiseaseDetail.vue?vue&type=style&index=0&id=1cfccd06&prod&scoped=true&lang=css"
import style1 from "./mzDiseaseDetail.vue?vue&type=style&index=1&id=1cfccd06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfccd06",
  null
  
)

export default component.exports